import * as actions from './discountCoupon/actions'
import * as mutations from './discountCoupon/mutations'
import * as getters from './discountCoupon/getters'

import { dataProps } from './discountCoupon/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/discountCoupon.js